import React, { Component } from 'react';
import { FaEnvelope, FaHome, FaWhatsapp } from 'react-icons/fa';
import retiraMascaraTelefone from '../utils/retiraMascaraTelefone';

const Atendimento = ({ revenda }) => {
    const {
        horario_seg_sex,
        horario_sab,
        peendereco_fiscal,
        peendereco_fiscal_numero,
        peendereco_fiscal_compl,
        pebairro_fiscal,
        pecidade,
        peuf,
        petelefone3,
        peemail,
    } = revenda;

    const whatsappLink = petelefone3
        ? `https://api.whatsapp.com/send?phone=55${retiraMascaraTelefone(petelefone3, "link")}`
        : null;

    return (
        <div className="col-12 col-md-6">
            <div className="b-contacts__address">
                <div className="b-contacts__address-hours">
                    <h2 className="s-titleDet wow zoomInUp" data-wow-delay="0.5s">
                        Atendimento
                    </h2>
                    <div className="b-contacts__address-hours-main wow zoomInUp" data-wow-delay="0.5s">
                        <p>
                            {horario_seg_sex} <br />
                            {horario_sab}
                        </p>
                    </div>
                </div>

                <div className="b-contacts__address-info">
                    <h2 className="s-titleDet wow zoomInUp" data-wow-delay="0.5s">
                        Fale Conosco
                    </h2>
                    <address className="b-contacts__address-info-main wow zoomInUp" data-wow-delay="0.5s">
                        <div className="b-contacts__address-info-main-item">
                            <div className="row">
                                <div className="col-4">
                                    <FaHome className="me-2" />
                                    Endereço
                                </div>
                                <div className="col-8">
                                    <em>
                                        <p className="mb-0">
                                            {peendereco_fiscal} {peendereco_fiscal_numero} {peendereco_fiscal_compl} - {pebairro_fiscal}
                                            <br />
                                            {pecidade}-{peuf}
                                        </p>
                                    </em>
                                </div>
                            </div>
                        </div>

                        {whatsappLink && (
                            <div className="b-contacts__address-info-main-item">
                                <div className="row">
                                    <div className="col-4">
                                        <FaWhatsapp className="me-2 text-success" />
                                        WhatsApp
                                    </div>
                                    <div className="col-8">
                                        <em>
                                            <a href={whatsappLink}>{retiraMascaraTelefone(petelefone3)}</a>
                                        </em>
                                    </div>
                                </div>
                            </div>
                        )}

                        <div className="b-contacts__address-info-main-item">
                            <div className="row">
                                <div className="col-4">
                                    <FaEnvelope className="me-2" />
                                    E-mail
                                </div>
                                <div className="col-8">
                                    <em>
                                        <a href={`mailto:${peemail}`} style={{color:"#FFF"}}>{peemail}</a>
                                    </em>
                                </div>
                            </div>
                        </div>
                    </address>
                </div>
            </div>
        </div>
    );
};

export default Atendimento;